import { Box, Divider } from '@mui/material';
import { PieChart } from '@mui/x-charts';
import { useGetOne, useTranslate } from 'react-admin';

import { GetCampaignsDashboardAnswerRateIdEndpoint } from '@Common/types/bo/b2b/campaigns/dashboard';

import { ShowSection } from '@sh4res/bo-common/components';
import {
  LegendLabel,
  PieCenterLabel,
} from '@sh4res/bo-common/components/B2bCompanyDashboard/utils';

export function AnswerRateChart({ id, resource }: { id: number; resource: string }) {
  const translate = useTranslate();

  const { data } = useGetOne<GetCampaignsDashboardAnswerRateIdEndpoint['Client']['ResponseBody']>(
    `${resource}/dashboard/answer_rate`,
    { id },
  );

  if (!data) {
    return null;
  }

  const pieData = [
    {
      id: 'at_least_one',
      value: data.at_least_one_employee_count,
      label: translate(
        'resources.bo_common.b2b.campaigns.dashboard.answer_rate.legend.at_least_one',
      ),
      color: '#594FF4',
    },
    {
      id: 'inactive',
      value: data.inactive_employee_count,
      label: translate('resources.bo_common.b2b.campaigns.dashboard.answer_rate.legend.inactive'),
      color: 'rgba(89, 79, 244, 0.2)',
    },
  ];

  return (
    <>
      <ShowSection label="resources.bo_common.b2b.campaigns.dashboard.answer_rate.label">
        <Divider />
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ paddingLeft: '60px' }}>
            <PieChart
              series={[
                {
                  data: pieData,
                  innerRadius: 135,
                  valueFormatter: (entry) =>
                    formatAnswerRateValue(entry.value, data.total_employee_count),
                },
              ]}
              height={350}
              width={400}
              slotProps={{
                legend: {
                  hidden: true,
                },
              }}>
              <PieCenterLabel
                total={formatAnswerRateValue(data.total_employee_count)}
                label={'resources.bo_common.b2b.campaigns.dashboard.answer_rate.chart.center_label'}
              />
            </PieChart>
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              flexDirection: 'column',
            }}>
            {pieData.map((entry, idx) => (
              <LegendLabel
                key={idx}
                id={String(idx)}
                color={entry.color}
                label={entry.label}
                value={formatAnswerRateValue(entry.value, data.total_employee_count)}
              />
            ))}
          </Box>
        </Box>
      </ShowSection>
    </>
  );
}

function formatAnswerRateValue(value: number, total?: number) {
  const percentage =
    total !== undefined && total !== 0 ? `(${Math.round((value / total) * 100)}%)` : '';
  return `${value.toLocaleString()} ${percentage}`;
}
